export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'Testimonials',
    pathname: '/',
    hash: '#testimonials',
  },
  {
    label: 'Skills',
    pathname: '/',
    hash: '#skills',
  },
  {
    label: 'Details',
    pathname: '/',
    hash: '#details',
  },
  // {
  //   label: 'Articles',
  //   pathname: '/articles',
  // },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'Linkedin',
    url: 'https://www.linkedin.com/in/hashanjayalath',
    icon: 'linkedin',
  },
  {
    label: 'Medium',
    url: 'https://medium.com/@hashaneranda',
    icon: 'medium',
  },
  {
    label: 'Github',
    url: 'https://github.com/hashaneranda',
    icon: 'github',
  },
];
